export type BorderRadius = "Rounded" | "Smooth" | "Square";
export const BorderRadiusValues: BorderRadius[] = ["Rounded", "Smooth", "Square"];
